export const transmissionCountState = {
  transmissionCount: {},
};
